export default {
	methods: {
		translator() {
			// const self = this;

			return {
				error(err) {
					const params = {
						text: 'Ocurrió un error descatalogado',
						notify: true,
					};

					switch (err) {
					case 'DEAL_NAME_REQUIRED':
						params.text = 'El nombre del chollo es obligatorio';
						break;

					case 'AUTH_REQUIRED':
						params.text = 'Debes estar logueado para poder hacer eso';
						break;

					case 'SERVER_UNREACHABLE':
						params.text = 'Nuestros servidores echan humo. Intenta en un rato.';
						break;

					case 'SERVER_ERROR':
						params.text = 'Ocurrió un error interno. Inténtalo en unos instantes.';
						break;

					case 'USERNAME_IN_USE':
						params.text = 'El nombre de usuario ya esta en uso';
						break;

					case 'MAIL_IN_USE':
						params.text = 'El email ya esta en uso';
						break;

					case 'SALE_PRICE_GREATER_THAN_OLD':
						params.text = 'El precio de ahora no puede ser superior al anterior';
						break;

					case 'PASSWORD_MISMATCH':
						params.text = 'La contraseña no es correcta';
						break;

					case 'USER_NOT_FOUND':
						params.text = 'El usuario no existe';
						break;

					case 'VERIFIED_ACCOUNT_NEEDED':
						params.text = 'Para poder hacer eso antes debes verificar tu cuenta';
						break;

					case 'USERNAME_NEEDED':
						params.notify = false;
						break;

					case 'TEXT_REQUIRED':
						params.text = 'El campo de texto es obligatorio';
						break;

					case 'CURRENT_PASSWORD_MISSING':
						params.text = 'Debes introducir tu contraseña actual';
						break;

					case 'CURRENT_AND_NEW_PASSWORDS_ARE_EQUAL':
						params.text = 'La nueva contraseña y la anterior son iguales';
						break;

					case 'ONLY_IMAGES_ALLOWED':
						params.text = 'Solo se permite adjuntar imágenes';
						break;

					case 'VALIDATION_ERROR':
						break;

					case 'DEAL_NOT_FOUND':
						params.text = 'Post no encontrado';
						break;

					case 'DESCRIPTION_VERY_SHORT':
						params.text = 'El Post ha de tener 50 palabras como mínimo. Sigue escribiendo. Ánimo!!!';
						break;
					case 'CHOLLOMETRO':
						params.text = 'ALERTA POR SUBNORMAL!! ALERTA POR SUBNORMAL!! VETE PARA CHOLLOMETRO TOPO!';
						break;
					case 'OFFER_URL_REPEAT':
						params.text = 'Fíjate, ibas a repetir un post que ha salido hace menos de 5 minutos!!!';
						break;

					default:
					}

					return params;
				},
			};
		},
	},

};
